import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod/v4';

import { InsightsPage } from '@/features/insights/components/insights-page';
import { requireOrganizationRoute } from '@/lib/router-guards';

const insightsSearchSchema = z.object({
    socialAccountId: z.string().optional()
});

export const Route = createFileRoute('/_app/insights')({
    beforeLoad: requireOrganizationRoute,
    component: InsightsPage,
    validateSearch: (search) => insightsSearchSchema.parse(search)
});
